<div class="justify-content-center row">

  <!-- New -->
  <div class="job-search-box container bg-white rounded-4 shadow-sm py-4 px-3" *ngIf="isHome">
    <form class="row gy-2 gx-3 align-items-center" data-aos="fade-up" data-aos-delay="100">
      <!-- Campo: Puesto o palabra clave -->
      <div class="col-md-5">
        <div class="input-group">
          <span class="input-group-text bg-white border-end-0">
            <i class="bi bi-briefcase text-secondary"></i>
          </span>
          <input type="text" class="form-control border-start-0" [value]="showJobName(searchControl.value)"
            [formControl]="searchControl" matInput placeholder="{{'jobkeyword' | translate}}" [matAutocomplete]="auto"
            required>
          <mat-autocomplete class="autocomplete-home" #auto="matAutocomplete">
            <mat-option *ngFor="let item of filteredItems | async" (click)="selectItem(item)">
              {{ item.puesto }}
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>

      <!-- Campo: Ubicación -->
      <div class="col-md-4">
        <div class="input-group">
          <span class="input-group-text bg-white border-end-0">
            <i class="bi bi-geo-alt text-secondary"></i>
          </span>
          <input class="form-control border-start-0" [value]="showLocationName(locationSearchControl.value)" type="text"
            [formControl]="locationSearchControl" matInput placeholder="{{'location' | translate}}"
            [matAutocomplete]="locationAuto">

          <mat-autocomplete class="autocomplete-home" #locationAuto="matAutocomplete">
            <mat-option *ngFor="let item of filteredLocationItems | async" (click)="selectLocationItem(item)">
              {{ item.entidad }}
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
      <!-- Botón: Buscar -->
      <div class="col-md-3">
        <button class="btn btn-primary w-100 d-flex align-items-center justify-content-center btn-sm"
          (click)="searchJobOpenning()">
          <i class="bi bi-search me-2"></i> {{'search-job' | translate}}
        </button>
      </div>
      <div class="text-danger" *ngIf="searchControl.touched && searchControl.errors?.['required']">
        El puesto o palabra clave es obligatorio.
      </div>
    </form>
  </div>

  <!-- Buscador -->
  <div *ngIf="!isHome">
    <div class="container bg-white py-3 px-4 rounded-4 shadow-sm mb-4">
      <form class="row gy-2 gx-3 align-items-center">
        <!-- Campo: Puesto o palabra clave -->
        <div class="col-md-4">
          <div class="input-group">
            <span class="input-group-text bg-white border-end-0"><i class="bi bi-briefcase text-secondary"></i></span>
            <!-- <input type="text" class="form-control border-start-0" placeholder="Puesto o palabra clave"> -->
            <input type="text" class="form-control border-start-0" [value]="showJobName(searchControl.value)"
              [formControl]="searchControl" matInput placeholder="{{'jobkeyword' | translate}}"
              [matAutocomplete]="auto">

            <mat-autocomplete class="autocomplete-home" #auto="matAutocomplete">
              <mat-option *ngFor="let item of filteredItems | async" (click)="selectItem(item)">
                {{ item.puesto }}
              </mat-option>
            </mat-autocomplete>
          </div>
        </div>

        <!-- Campo: Ubicación -->
        <div class="col-md-4">
          <div class="input-group">
            <span class="input-group-text bg-white border-end-0"><i class="bi bi-geo-alt text-secondary"></i></span>
            <input class="form-control border-start-0" [value]="showLocationName(locationSearchControl.value)"
              type="text" [formControl]="locationSearchControl" matInput placeholder="{{'location' | translate}}"
              [matAutocomplete]="locationAuto">

            <mat-autocomplete class="autocomplete-home" #locationAuto="matAutocomplete">
              <mat-option *ngFor="let item of filteredLocationItems | async" (click)="selectLocationItem(item)">
                {{ item.entidad }}
              </mat-option>
            </mat-autocomplete>
          </div>
        </div>

        <!-- Botón de búsqueda -->
        <div class="col-md-4">
          <button class="btn btn-sm btn-primary w-50" (click)="searchJobOpenning()">
            <i class="bi bi-search me-1"></i> Buscar
          </button>
          <button class="btn btn-sm btn-danger w-50" (click)="clearFilters()">
            <i class="bi bi-x"></i> Limpiar Filtros
          </button>
        </div>
        <div class="text-end">
          <button class="btn btn-light border d-flex align-items-center gap-2 px-3 py-2 shadow-sm rounded-pill"
            (click)="mostrarFiltros = !mostrarFiltros">
            <i class="bi bi-sliders"></i>
            <span>{{ mostrarFiltros ? 'Ocultar filtros avanzados' : 'Mostrar filtros avanzados' }}</span>
          </button>
        </div>
      </form>

      <!-- Filtros adicionales debajo -->
      <div *ngIf="mostrarFiltros" class="mt-3 filtros-adicionales" [@slideDownUp]
        class="mt-3 border rounded p-3 bg-light">
        <div class="row mt-3">
          <div class="col-md-4">
            <label>Fecha de publicación</label>
            <select id="post-date-select" (change)="filterChanged($event)" [formControl]="postDateControl"
              class="form-select">
              <option *ngFor="let opt of postDateOptions" [value]="opt.label">{{opt.label | translate}}</option>
            </select>
            <button *ngIf="postDateControl.value!='0'"
              class="btn position-absolute top-50 end-0 translate-middle-y me-1 border-0"
              style="background-color: #fff;" type="button" (click)="cleanSelect('postDate')">
              ✖
            </button>
          </div>

          <div class="col-md-4">
            <label>Sueldo</label>
            <select id="post-date-select" (change)="filterChanged($event)" [formControl]="salaryControl"
              class="form-select">
              <option *ngFor="let opt of salaryItems" [value]="opt.sueldo">{{opt.sueldo | translate}}</option>
            </select>
            <button *ngIf="salaryControl.value!='-1'"
              class="btn position-absolute top-50 end-0 translate-middle-y me-1 border-0"
              style="background-color: #fff;" type="button" (click)="cleanSelect('salary')">
              ✖
            </button>
          </div>

          <!--div *ngIf="hasFilters" class="col-md-4">
            <button (click)="cleanFilters()" class="btn btn-erase-filter btn-outline-primary">
              <i class="bi bi-x"></i>
              {{"erase-filter" | translate}}

            </button>
          </div-->
        </div>
      </div>
    </div>
  </div>
</div>